export var TRIGGER_TYPE = /* @__PURE__ */ ((TRIGGER_TYPE2) => {
  TRIGGER_TYPE2["BUYER_EVENT"] = "buyer_event";
  TRIGGER_TYPE2["AUTOMATION"] = "automation";
  return TRIGGER_TYPE2;
})(TRIGGER_TYPE || {});
